<template>
  <div class="list-view-page">
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["1911"]') }}</span>
      <!-- 列表视图设置 -->
      <span slot="secondTit">{{ $t('message[1911]') }}</span>
    </crumb-tit>
    <a-tabs
      :active-key="activeKey"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        v-for="item in datas"
        :key="item.roleid"
        :tab="item.rolename"
      >
        <!-- 信息列表 -->
        <a-form-item :label="$t('message[1912]')">
          <a-cascader
            :value="listSelect"
            :options="menuOptions"
            :field-names="{label: 'name', value: 'id', children: 'child'}"
            :allow-clear="false"
            :placeholder="$t('message[1326]')"
            @change="onChangeList"
          />
        </a-form-item>
        <!-- 开启视图功能 -->
        <a-form-item
          :label="$t('message[1913]')"
          class="clearfix"
        >
          <a-switch
            :checked="isOpen"
            @change="handleChangeOpen"
          />
          <!-- 已开启/已关闭 -->
          {{ isOpen ? $t('message[1466]') : $t('message[1459]') }}
          <!-- 创建视图 -->
          <a-button
            type="primary"
            class="fr"
            @click="handleCreate"
          >
            {{ $t('message[1914]') }}
          </a-button>
        </a-form-item>
        <main-list
          :list-data="viewList"
          :page="listSelect[1]"
          :role="activeKey"
          @updateList="updateList"
        />
      </a-tab-pane>
    </a-tabs>
    <view-detail
      :id="viewId"
      :view-name="viewName"
      :visible.sync="showDetailModal"
      :page="listSelect[1]"
      :role="activeKey"
      @updateList="updateList"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CrumbTit from '@/components/pc/config/CrumbTit'
import MainList from './List'
import ViewDetail from './ViewDetail'

export default {
  name: 'ListView',
  components: {
    CrumbTit,
    MainList,
    ViewDetail
  },
  data () {
    return {
      activeKey: '',
      listSelect: [],
      isOpen: false,
      showDetailModal: false,
      viewId: null,
      viewName: ''
    }
  },
  computed: {
    ...mapState('config/setlist', ['datasReady', 'datas']),
    ...mapState('config/listview', ['menuOptions', 'viewList', 'isSwitch']),

    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      document.title = this.$t('message["1911"]') + projectname + comname
      return this.$t('message["1911"]') + projectname + comname
    }
  },
  watch: {
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },
  async created () {
    this.getTabData()
    this.$bus.$on('showDetailModal', (id, name) => {
      this.showDetailModal = true
      this.viewId = id
      this.viewName = name
    })
  },
  methods: {
    ...mapActions('config/setlist', ['getlistRolesDatas']),
    ...mapActions('config/listview', ['getMenuOptions', 'getViewList', 'setSwitchView', 'getSwitchView']),
    async getTabData () {
      const chain = await this.getlistRolesDatas()
      chain.onSuccess(async (raw) => {
        if (raw.length) {
          this.activeKey = raw[0].roleid
          await this.getMenuOptions({
            roleid: this.activeKey,
            system_role: raw[0].system_role
          })
          if (this.menuOptions[0] && this.menuOptions[0].child[0]) {
            this.listSelect = [this.menuOptions[0].id, this.menuOptions[0].child[0].id]
            this.initData()
          }
        }
      }).fetch()
    },
    async tabCallback (key) {
      this.activeKey = key
      const { datas } = this
      const activeData = datas.find(item => item.roleid === key)
      await this.getMenuOptions({
        roleid: key,
        system_role: activeData.system_role
      })
      if (this.menuOptions[0] && this.menuOptions[0].child[0]) {
        this.listSelect = [this.menuOptions[0].id, this.menuOptions[0].child[0].id]
        this.initData()
      }
    },
    onChangeList (value) {
      this.listSelect = value
      this.initData()
    },
    async initData () {
      await this.getSwitchView({
        role: this.activeKey,
        page: this.listSelect[1]
      })
      this.isOpen = this.isSwitch
      this.getViewList({
        role: this.activeKey,
        page: this.listSelect[1]
      })
    },
    async handleChangeOpen (val) {
      this.isOpen = val
      await this.setSwitchView({
        role: this.activeKey,
        page: this.listSelect[1]
      })
      await this.getViewList({
        role: this.activeKey,
        page: this.listSelect[1]
      })
    },
    handleCreate () {
      this.showDetailModal = true
      this.viewId = null
      this.viewName = ''
    },
    updateList ({ role, page }) {
      this.getViewList({
        role,
        page
      })
    }
  }
}
</script>

<style scoped lang="scss">
.list-view-page::v-deep {
  padding-bottom: 76px;
  .ant-tabs {
    margin-top: 24px;
  }
  .ant-tabs-nav-wrap {
    border-top: solid 1px #ebebeb;
  }
  .ant-tabs-bar {
    margin-bottom: 24px;
    border-bottom: 0 none;
  }
  .ant-tabs-nav {
    .ant-tabs-tab {
      margin-right: 16px;
      padding: 8px 2px;
      font-size: 18px;
      font-weight: bold;
      line-height: 32px;
    }
  }
  .ant-form-item-label {
    float: left;
  }
}
</style>
